import TransitionWrapper from "./transition-wrapper";

const LocationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="7"></circle>
    <circle cx="12" cy="12" r="3" fill="currentColor"></circle>
    <path d="M12 2v2"></path>
    <path d="M12 20v2"></path>
    <path d="M2 12h2"></path>
    <path d="M20 12h2"></path>
  </svg>
);

interface LocationButtonProps {
  onClick: () => void;
  variant?: "default" | "withTransition";
  className?: string;
}

const baseClassName =
  "flex flex-col items-center justify-center gap-0.5 rounded-md bg-[#1562fc] px-3 py-2 text-xs font-semibold leading-none text-white cursor-pointer select-none transition-[opacity] active:opacity-90";

/**
 * 내위치 찾기 버튼.
 * maps, location 등 지도 화면에서 공통 사용.
 */
const LocationButton = ({
  onClick,
  variant = "default",
  className = "",
}: LocationButtonProps) => {
  const content = (
    <>
      <LocationIcon />
      <span className="tracking-tight">내위치</span>
    </>
  );

  const buttonClassName = `${baseClassName} ${className}`.trim();

  if (variant === "withTransition") {
    return (
      <TransitionWrapper
        scale={0.95}
        opacity={0.8}
        className={buttonClassName}
        onClick={onClick}
      >
        {content}
      </TransitionWrapper>
    );
  }

  return (
    <div className={buttonClassName} onClick={onClick}>
      {content}
    </div>
  );
};

export default LocationButton;
